import React from 'react';
import { cardTiltLeave, cardTiltMove } from './t05CardTilt';

export interface T05GlowCardProps {
  gradient: string;
  glowOpacity?: number;
  glowBlur?: number;
  haloRadius?: number;
  surfaceRadius?: number;
  className?: string;
  surfaceClassName?: string;
  children: React.ReactNode;
}

export const T05GlowCard: React.FC<T05GlowCardProps> = ({
  gradient,
  glowOpacity = 0.28,
  glowBlur = 26,
  haloRadius = 22,
  surfaceRadius = 22,
  className = '',
  surfaceClassName = '',
  children,
}) => {
  return (
    <div
      className={`t05-glow-card${className ? ` ${className}` : ''}`}
      style={{ '--t05-glow-gradient': gradient } as React.CSSProperties}
    >
      <div
        className="t05-glow-card__halo"
        aria-hidden
        data-base-opacity={String(glowOpacity)}
        style={{
          opacity: glowOpacity,
          filter: `blur(${glowBlur}px)`,
          borderRadius: `${haloRadius}px`,
        }}
      />
      <div
        className={`t05-glow-card__surface${surfaceClassName ? ` ${surfaceClassName}` : ''}`}
        style={{ borderRadius: `${surfaceRadius}px` }}
        onMouseMove={cardTiltMove}
        onMouseLeave={cardTiltLeave}
      >
        {children}
      </div>
    </div>
  );
};
